export default "__VITE_ASSET__XV4tLL13__"